
<section>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6">
                <div class="container h-100 status-page-Background">
                    <div class="left-sec common-spacing">
                        <div class="survey-status" *ngIf="user_Status!=-1">
                            <h1>{{user_Status==3?'Congratulations'
                                :user_Status==4?'Quota Full'
                                :user_Status==5?'Terminate'
                                :user_Status==8?'No Survey'
                                :user_Status==9?'Security'
                                :user_Status==10?'Duplicate'
                                :'Terminate'}}</h1>
                            <h2>{{user_Status==3?'The survey is now completed':''}}</h2>
                            <p>{{user_Message}}</p>
                            <br>
                            <br>
                            <!-- <h5>{{next_Message}}</h5> -->

                            <ul class="button" *ngIf="!NoPromotion">
                                <li>
                                    <a class="btn btn-outline-primary btn-lg" href="https://opinionest.com/" target="_blank">Go to Homepage</a>
                                </li>
                                <li>
                                    <a class="btn btn-primary btn-lg" href="https://opinionest.com/contact-us" target="_blank">Contact Us</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 p-0">
                <div class="container h-100 status-page-Background">
                    <div class="common-spacing text-center h-100 d-flex align-items-center justify-content-center">
                        <img class="img-fluid" [src]="user_Status==3?'../../../assets/images/complete.png'
                        :user_Status==4?'../../../assets/images/Over-Quota.png'
                        :user_Status==5?'../../../assets/images/terminate-bg.png'
                        :user_Status==8?'../../../assets/images/No-survey.png'
                        :user_Status==9?'../../../assets/images/Security.png'
                        :user_Status==10?'../../../assets/images/Duplicate-survey.png'
                        :'../../../assets/images/terminate-bg.png'" alt="complete" width="1000" height="747"/>
                    </div>
                </div>
            </div>
            <div id="redirectDiv" [ngClass]="next_Message==''?'':'visible'"> {{next_Message}}
            </div>
        </div>
    </div>
</section>
